import { Alert, Autocomplete, Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, FormControl, Grid, InputLabel, LinearProgress, MenuItem, Paper, Select, TextField } from '@mui/material';
import React, { Component } from 'react';
import Global from '../../../customlib/Global';

class CreateTicketDataCancelDialog extends Component {
    state = { 
        data: null
    }
    
    componentDidMount() {
        this.setState({data: this.props.selectedData ? {...this.props.selectedData} : null});
    }

    handleGroupReasonChange = (event) => {
        const obData = {...this.state.data};
        obData.groupReason = event.target.value;
        obData.reason = "";
        this.setState({ data: obData});
    }
    
    handleReasonChange = (event) => {
        const obData = {...this.state.data};
        obData.reason = event.target.value;
        this.setState({ data: obData});
    }

    handleDataChange = (event, field) => {
        const obData = {...this.state.data};
        obData[field] = event.target.value;
        this.setState({data: obData});
    }

    handleCategoryChange = (event, newValue) => {
        let selected = {...this.state.data};
        let findCategory = this.props.productCategories?.find(item => item.label === newValue.label);
        console.log("LOG___cate", findCategory, "NEWVALUE : ", newValue, "DATA", selected);
        selected.lavenderProductCategory = findCategory;
        if(findCategory){
            this.setState({data: selected});
        }
    }

    handleCityOnChange = (newCity) => {
        let selected = this.props.listCity.filter((city) => city.name===newCity);
        let obData = {...this.state.data};
        if(selected.length > 0){
            obData.cityId = selected[0].id;
            obData.cityName = selected[0].name;
            obData.selectedCity = selected;
            this.setState({data: obData}, () => {
            console.log("SELECTED CITY", selected[0]);
            });
        }
    }


    render() { 

        // if(!this.state.data && this.props.isDialogOpen){
        //     return (
        //         <Dialog open={this.props.isDialogOpen ?? false} onClose={this.props.onClose}>
        //             <DialogTitle>Invalid Data</DialogTitle>
        //             <DialogContent>
        //                 <DialogContentText>
        //                     Customer belum dipilih
        //                 </DialogContentText>
        //             </DialogContent>
        //         </Dialog>
        //     );
        // }

        return (
            <Dialog open={this.props.isDialogOpen ?? false} onClose={this.props.onClose}>
                <DialogTitle>
                    Submit Ticket
                    <Divider />
                    {
                        this.props.isLoadingAnalisa && <LinearProgress />
                    }
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        
                    </DialogContentText>
                    <Paper elevation={0} sx={{p: "10px", border: "solid 1px", borderRadius: "5px", mb: "10px"}}>
                        <Grid container spacing={1}>
                            <Grid item xs={6} sx={{fontWeight: "bold"}}>{this.state.data?.fromName}</Grid>
                            <Grid item xs={6} textAlign={"right"} sx={{fontWeight: "bold"}}>{this.state.data?.from}</Grid>
                            {/* <Grid item xs={6}>Kategori Produk : {this.state.data?.productCategory}</Grid> */}
                            <Grid item xs={12}>{this.state.data?.cityName}</Grid>
                        </Grid>
                    </Paper>
                    {
                        this.props.errorMessage !== "" && <Alert sx={{mt: "10px"}} severity="error">{this.props.errorMessage}</Alert>
                    }
                    
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <TextField multiline value={this.state.data?.issue} onChange={(event) => this.handleDataChange(event, "issue")} id="txt_ringkasan_masalah" label="Issue" variant="outlined" fullWidth size='small' />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl disabled sx={{mt: "20px"}} size="small" variant="outlined" style={{width: '100%', marginTop: "15px"}}>
                                <InputLabel id="cb-group-reason">Pilih Kategori Masalah</InputLabel>
                                <Select
                                labelId="cb-group-reason"
                                id="cb-group-reason"
                                defaultValue={this.state.data?.groupReason}
                                value={this.state.data?.groupReason}
                                onChange={this.handleGroupReasonChange}
                                label="Group Alasan"
                                >
                                {
                                    Global.treeReasonCancel.map(
                                    (cat) => {
                                        return (<MenuItem key={cat.group.toLowerCase()} value={cat.group}>{cat.group}</MenuItem>);
                                    } 
                                    )
                                }
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl disabled sx={{mt: "20px", mb: "0px"}} size="small" variant="outlined" style={{width: '100%', marginTop: "15px"}}>
                                <InputLabel id="cb-reason">Pilih Sub Kategori Masalah</InputLabel>
                                <Select
                                
                                labelId="cb-reason"
                                id="cb-reason"
                                value={this.state.data?.reason}
                                onChange={this.handleReasonChange}
                                label="Alasan"
                                >
                                {
                                    this.state.data?.groupReason && this.state.data?.groupReason.length > 0 && Global.treeReasonCancel.find(item => item.group === this.state.data?.groupReason)?.reasons?.map(
                                    (cat) => {
                                        return (<MenuItem key={cat.toLowerCase()} value={cat}>{cat}</MenuItem>);
                                    } 
                                    )
                                }
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl fullWidth size='small' sx={{}}>
                                <InputLabel id="todo">To Do</InputLabel>
                                <Select
                                    labelId={"todo"}
                                    id={"select-todo"}
                                    value={this.state.data?.todo}
                                    label="Divisi Tujuan"
                                    onChange={(event) => this.handleDataChange(event, "todo")}
                                    size='small'
                                    // sx={{fontSize: "12px"}}
                                >
                                    <MenuItem value={"HR"}>HR</MenuItem>
                                    <MenuItem value={"Finance"}>Finance</MenuItem>
                                    <MenuItem value={"IT"}>IT</MenuItem>
                                    <MenuItem value={"Akuisisi"}>Akuisisi</MenuItem>
                                    <MenuItem value={"Supply Chain"}>Supply Chain</MenuItem>
                                    <MenuItem value={"Module Training"}>Module Training</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <Autocomplete
                                // disablePortal
                                id="auto-kategori-produk"
                                options={this.props.productCategories}
                                renderInput={(params) => <TextField {...params} label="Kategori Produk" />}
                                onChange={(event, newValue) => this.handleCategoryChange(event, newValue)}
                                onInputChange={(event, newValue) => this.handleCategoryChange(event, newValue)}
                                // autoHighlight
                                // freeSolo={true}
                                size='small'
                            />
                            {/* <Autocomplete
                                id="free-solo-2-demo"
                                // disableClearable
                                freeSolo 
                                options={this.props.productCategories.map((option) => {
                                    // console.log("LABEL : ", option);
                                    return String(option.label);
                                })}
                                onChange={(event, newValue) => {
                                    // console.log("NEWVALUE : ", event);
                                    this.handleCategoryChange(event ,newValue);
                                }} 
                                value={this.state.data.selectedProductCategory}
                                renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Pilih Jenis Produk"
                                    margin="0"
                                    variant="outlined"
                                    InputProps={{ ...params.InputProps, type: 'search' }}
                                />
                                )}
                                size="small"
                            /> */}
                        </Grid>
                        {/* <Grid item xs={12}>
                            <Autocomplete
                                id="free-solo-2-demo"
                                // disableClearable
                                freeSolo 
                                options={this.props.listCity.map((option) => {
                                    // console.log("LABEL : ", option);
                                    return String(option.name);
                                })}
                                onChange={(event, newValue) => {
                                    // console.log("NEWVALUE : ", event);
                                    this.handleCityOnChange(newValue);
                                }} 
                                value={this.state.data.selectedCity}
                                renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Pilih Kota"
                                    margin="0"
                                    variant="outlined"
                                    InputProps={{ ...params.InputProps, type: 'search' }}
                                />
                                )}
                                size="small"
                            />
                        </Grid> */}

                        <Grid item xs={12}>
                            <TextField multiline value={this.state.data?.issueDescription} onChange={(event) => this.handleDataChange(event, "issueDescription")} id="txt_ringkasan_masalah" label="Ringkasan Masalah" variant="outlined" fullWidth size='small' />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField multiline value={this.state.data?.issueDetail} onChange={(event) => this.handleDataChange(event, "issueDetail")} id="txt_ringkasan_masalah" label="Detail Request" variant="outlined" fullWidth size='small' />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField disabled value={this.state.data?.feedback} onChange={(event) => this.handleDataChange(event, "feedback")} id="txt_feedback" label="Input Penyelesaian" variant="outlined" fullWidth size='small' />
                        </Grid>
                        {/* <Grid item xs={6}>
                            <TextField disabled value={this.state.data?.why1} onChange={(event) => this.handleDataChange(event, "why1")} id="txt_why1" label="Why 1" variant="outlined" fullWidth size='small' />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField disabled value={this.state.data?.why2} onChange={(event) => this.handleDataChange(event, "why2")} id="txt_why2" label="Why 2" variant="outlined" fullWidth size='small' />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField disabled value={this.state.data?.why3} onChange={(event) => this.handleDataChange(event, "why3")} id="txt_why3" label="Why 3" variant="outlined" fullWidth size='small' />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField disabled value={this.state.data?.why4} onChange={(event) => this.handleDataChange(event, "why4")} id="txt_why4" label="Why 4" variant="outlined" fullWidth size='small' />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField disabled value={this.state.data?.why5} onChange={(event) => this.handleDataChange(event, "why5")} id="txt_why5" label="Why 5" variant="outlined" fullWidth size='small' />
                        </Grid> */}
                        
                    </Grid>
                    <Divider />
                </DialogContent>
                <DialogActions>
                    <Button variant='contained' color='warning' onClick={this.props.onClose} sx={{textTransform: "capitalize"}}>Batal</Button>
                    <Button variant='contained' color={"primary"} disabled={this.props.isSubmiting} onClick={() => this.props.onSubmit(this.state.data)} sx={{textTransform: "capitalize"}}>
                        Simpan
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}
 
export default CreateTicketDataCancelDialog;